import { render, staticRenderFns } from "./FormSubtitle.vue?vue&type=template&id=0d754020"
import script from "./FormSubtitle.vue?vue&type=script&lang=js"
export * from "./FormSubtitle.vue?vue&type=script&lang=js"
import style0 from "./FormSubtitle.vue?vue&type=style&index=0&id=0d754020&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports